import { ISortedPageRequest } from '../common/interfaces/IPageRequest';

export interface IFuelInvoice {
  remoteDocumentId: number;
  paymentAmount: number;
  totalAmount: number;
  documentNumber: string;
  documentType: DocumentType;
  paid: boolean;
  documentDateCreated: string;
  paymentDeadlineDate: string;
  printForm: string;
  remoteFactoring?: string;
}

export enum IFuelInvoiceSortFields {
  REMOTE_DOCUMENT_ID = 'REMOTE_DOCUMENT_ID',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  DOCUMENT_TYPE = 'DOCUMENT_TYPE',
  DOCUMENT_DATE_CREATED = 'DOCUMENT_DATE_CREATED',
  PAYMENT_DEADLINE_DATE = 'PAYMENT_DEADLINE_DATE',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT',
  IS_PAID = 'IS_PAID',
}

export interface IFuelInvoiceRequest extends ISortedPageRequest<IFuelInvoiceSortFields> {
  onlyNotPaid?: boolean;
  types?: string | string[];
  documentDateCreatedStart?: string;
  documentDateCreatedEnd?: string;
}

export enum DocumentType {
  LV_5 = 'LV.5',
  LV_5A = 'LV.5A',
  LV_5E = 'LV.5E',
  LV_K = 'LV.K',
  VA_1 = 'VA.1',
  MV_KO = 'MV.KO',
  MV_VF = 'MV.VF',
  MV_VL = 'MV.VL',
  RM_5A = 'RM.5A',
}

export const DOCUMENT_TYPES_AGGREGATE = 'VA_1';
export const DOCUMENT_TYPES_MULTI = 'MV_KO,MV_VL';

export enum FuelInvoiceFilterType {
  DATE = 'DATE',
  TYPE = 'TYPE',
}
export enum FuelInvoiceType {
  ALL = 'ALL',
  AGGREGATE_BILL = 'AGGREGATE_BILL',
  MULTI_BILL = 'MULTI_BILL',
}

export const INVOICE_TYPE_FILTER_OPTIONS = [
  {
    label: 'Kõik arved',
    value: FuelInvoiceType.ALL,
  },
  {
    label: 'Koondarve',
    value: FuelInvoiceType.AGGREGATE_BILL,
  },
  {
    label: 'Hulgiarve',
    value: FuelInvoiceType.MULTI_BILL,
  },
];